import { ChangeEventHandler, useState } from "react";
import css from "./Coordinates.module.css";

interface CoordinatesProps {
	x: number;
	y: number;
	setY: ChangeEventHandler<HTMLInputElement>;
	setX: ChangeEventHandler<HTMLInputElement>;
}

export function Coordinates({ x, y, setY, setX }: CoordinatesProps) {
	const [editCoordinates, setEditCoordinates] = useState<boolean>(false);

	return (
		<div onClick={() => setEditCoordinates(true)}>
			{editCoordinates ? (
				<div className={css.divCoordinates}>
					<label>X:</label>
					<input value={x} onChange={setX} />
					<label>Y:</label>
					<input value={y} onChange={setY} />
					<button
						onClick={(e) => {
							e.stopPropagation();
							setEditCoordinates(false);
						}}
						className={css.buttonCoordinates}
					>
						x
					</button>
				</div>
			) : (
				<div className={css.divCoordinates}>
					X: {x} Y: {y}
				</div>
			)}
		</div>
	);
}
